export class ApiError extends Error {
  constructor(message, status, data) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.data = data;
  }
}

const SENSITIVE_PATTERNS = [
  /user_id/i,
  /email/i,
  /password/i,
  /token/i,
  /session/i,
  /credential/i,
  /secret/i,
  /private/i,
  /\d{4,}/g
];

export function sanitizeErrorMessage(message) {
  if (!message || typeof message !== 'string') {
    return '操作失败，请稍后重试';
  }
  
  let sanitized = message;
  
  SENSITIVE_PATTERNS.forEach(pattern => {
    sanitized = sanitized.replace(pattern, '[已隐藏]');
  });
  
  return sanitized;
}

export function extractErrorMessage(error) {
  if (error instanceof ApiError) {
    return error.message;
  }
  
  if (error.response?.data) {
    const data = error.response.data;
    
    if (typeof data.detail === 'string') {
      return sanitizeErrorMessage(data.detail);
    }
    
    if (Array.isArray(data.detail)) {
      const sanitizedDetails = data.detail.map(err => {
        const msg = err.msg || JSON.stringify(err);
        return sanitizeErrorMessage(msg);
      });
      return sanitizedDetails.join(', ');
    }
    
    if (typeof data === 'string') {
      return sanitizeErrorMessage(data);
    }
    
    if (data.message) {
      return sanitizeErrorMessage(data.message);
    }
  }
  
  if (error.message) {
    return sanitizeErrorMessage(error.message);
  }
  
  return '请求失败，请稍后重试';
}

export function handleApiError(error, defaultMessage = '操作失败') {
  const message = extractErrorMessage(error);
  throw new ApiError(message, error.response?.status, error.response?.data);
}

export function cleanParams(params) {
  const cleanParams = {};
  Object.keys(params).forEach(key => {
    if (params[key] !== '' && params[key] !== null && params[key] !== undefined) {
      cleanParams[key] = params[key];
    }
  });
  return cleanParams;
}

export function createApiHandler(apiCall, errorMessage = '操作失败') {
  return async (...args) => {
    try {
      const response = await apiCall(...args);
      return response.data;
    } catch (error) {
      handleApiError(error, errorMessage);
    }
  };
}
